import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false;

// element-ui配置
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 调用插件
Vue.use(ElementUI);

// 导入css初始化样式
import "/static/css/reset.css";

import "/static/css/style.css";

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)


import axios from "axios"
axios.defaults.withCredentials = false; // false表示阻止ajax附带cookie
Vue.prototype.$axios = axios; // 把对象挂载vue中

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
